<Menu></Menu><router-view></router-view><Footer></Footer>